import { render } from "./BNavbarBrand.vue?vue&type=template&id=1fce672b&ts=true"
import script from "./BNavbarBrand.vue?vue&type=script&lang=ts"
export * from "./BNavbarBrand.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__